import React, { useRef } from 'react'
import Header from '../components/Header'
import { Button, TextField } from '@mui/material'
import SendIcon from '@mui/icons-material/Send';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import AccountCircle from '@mui/icons-material/AccountCircle';
import AlternateEmailIcon from '@mui/icons-material/AlternateEmail';
import CallIcon from '@mui/icons-material/Call';
import DirectionsCarIcon from '@mui/icons-material/DirectionsCar';
import BentoIcon from '@mui/icons-material/Bento';

import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import InputAdornment from '@mui/material/InputAdornment';

import IconButton from '@mui/material/IconButton';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { Link, NavLink, useNavigate } from 'react-router-dom'

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import MenuItem from '@mui/material/MenuItem';

import { Swiper, SwiperSlide } from 'swiper/react';
import { EffectCoverflow, Pagination, Autoplay } from 'swiper/modules';
import 'swiper/css';

import { useForm, SubmitHandler } from "react-hook-form"
import { contact } from '../components/ApiService';
import Swal from 'sweetalert2';


import './Home.css'
import memberList from '../Shared/TeamMembers';
import Footer from '../components/Footer';
import Gallery from './Gallery';
import { useEffect } from 'react';


const Home = ({ galleryRef, contactRef }) => {
    const navigate = useNavigate()
    const [open, setOpen] = React.useState(false);

    const handleClickOpenCar = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const scheduleRide = () => {

    }

    useEffect(() => {
        setTimeout(() => {
            setOpen(true);
        }, 1000);        
    }, [])


    // FORM HANDLING
    const {
        register,
        handleSubmit,
        reset,
        watch,
        formState: { errors, isSubmitting },
    } = useForm()

    async function onSubmit(data) {

        // SEND MESSAGE TO WHATSAPP NUMBER
        const phoneNumber = "917003900368"; //7003900368

        const message = `
            * New Vehicle Inquiry*
            ------------------------
             Name: ${data.firstName} ${data.lastName}
             Email: ${data.email}
             Contact: ${data.contact}

             Vehicle Brand: ${data.brandName}
             Vehicle Name: ${data.carName}
             Vehicle Type: ${data.carType || "N/A"}

             Subject: ${data.subject || "N/A"}
             Message: ${data.message || "N/A"}
        `;

    const encodedMessage = encodeURIComponent(message);
    const whatsappURL = `https://wa.me/${phoneNumber}?text=${encodedMessage}`;

    window.open(whatsappURL, "_blank");
    setOpen(false);
    reset();


        // API CALL HERE TO MAIL VIA TWILLIO SENDGRID
        // const obj = {
        //     firstName: data.firstName,
        //     lastName: data.lastName,
        //     emailAddress: data.email,
        //     phoneNumber: data.contact,
        //     vehicleName: data.brandName + ' ' + data.carName,
        //     vehicleType: data.carType,
        //     subject: data.subject,
        //     message: data.message
        // }
        // await contact(obj).then((res) => {
        //     console.log(res, "RES");
        //     // alert("Your request has been submitted successfully. We will get back to you soon!")
        //     const Toast = Swal.mixin({
        //         toast: true,
        //         position: "top-end",
        //         showConfirmButton: false,
        //         timer: 3000,
        //         timerProgressBar: true,
        //         didOpen: (toast) => {
        //             toast.onmouseenter = Swal.stopTimer;
        //             toast.onmouseleave = Swal.resumeTimer;
        //         }
        //     });
        //     Toast.fire({
        //         icon: "success",
        //         title: res.data.message
        //     });
        //     setOpen(false);
        //     reset();
        // }).catch((error) => {
        //     console.log(error, "ERR");
        //     const Toast = Swal.mixin({
        //         toast: true,
        //         position: "top-end",
        //         showConfirmButton: false,
        //         timer: 3000,
        //         timerProgressBar: true,
        //         didOpen: (toast) => {
        //             toast.onmouseenter = Swal.stopTimer;
        //             toast.onmouseleave = Swal.resumeTimer;
        //         }
        //     });
        //     Toast.fire({
        //         icon: "error",
        //         title: error?.response?.data.message ? error?.response?.data.message : "Something Went Wrong!" 
        //     });
        // })

        console.log(data, "MESSAGE");
    }

    // TABLE DATA
    const rows = [
        { url: 'images/keys.png', title: 'Free Doorstep Pick-Up And Drop', right: 'images/check.png', wrong: 'images/cross.png' },
        { url: 'images/tracking-app.png', title: 'Online Service Tracking', right: 'images/check.png', wrong: 'images/cross.png' },
        { url: 'images/mechanical-engineering.png', title: 'Top Rated Mechanics', right: 'images/check.png', wrong: 'images/cross.png' },
        { url: 'images/service.png', title: 'Smart Vehicle History', right: 'images/check.png', wrong: 'images/cross.png' },
        { url: 'images/certified.png', title: '100% Certified Parts', right: 'images/check.png', wrong: 'images/cross.png' },
    ];

    // // SCROLL TO GALLERY SECTION
    // const galleryRef = useRef(null) //CREATE REF OF THE GALLERY SECTION
    // const handleScrollToGallery = () => {
    //     if(galleryRef.current){
    //         galleryRef.current?.scrollIntoView({ behavior: 'smooth' });
    //     }
    // };

    // // SCROLL TO CONTACT US
    // const contactRef = useRef(null) //CREATE REF OF THE CONTACT US
    // const handleScrollToContact = () => {
    //     if(contactRef.current){
    //         contactRef.current?.scrollIntoView({ behavior: 'smooth'})
    //     }
    // }


    return (
        <>
            {/* <Header onScrollToGallery={handleScrollToGallery} onScrollToContact={handleScrollToContact} /> */}

            <section className='bannerCont'>
                <img src='images/banner1.jpg' className='img-fluid' alt='carGenie' />
                <div className='wheelRotate'>
                    <img src='images/wheel.png' className='img-fluid rotate-center' alt='carGenie' />
                </div>
                <div className='bannerContent'>
                    <h1>We offer <span>quick</span> and <span>reliable</span> repairs for all makes and models.</h1>
                    <div className='d-flex bannerCntent'>
                        <Button variant="contained" size="large" className='roundedBox buttonBlue me-3' href="https://api.whatsapp.com/send?phone=7003900368" startIcon={<WhatsAppIcon />}> Connect Genie  </Button>
                        <Button variant="outlined" size="large" className='roundedBox buttonBlue' endIcon={<SendIcon />} onClick={handleClickOpenCar}>Get Free Quote</Button>
                    </div>
                </div>
            </section>

            <section className='service'>
                <div className='container'>
                    <div className='serviceCont'>
                        <h6> Our Curated </h6>
                        <h1> Services </h1>
                        <ul>
                            <li>
                                <img src='images/periodic-maintenance.png' className='img-fluid' alt='carGenie' />
                                <div className='contentDetails'>
                                    <label> Periodic Maintenance </label>
                                    <span> For a safe and smooth driving experience </span>
                                </div>
                                <Link to="">
                                    <IconButton aria-label="delete">
                                        <ChevronRightIcon />
                                    </IconButton>
                                </Link>
                            </li>

                            <li>
                                <img src='images/express-service.png' className='img-fluid' alt='carGenie' />
                                <div className='contentDetails'>
                                    <label> Express Car Service </label>
                                    <span> Delivers fast, reliable, and thorough car maintenance solutions. </span>
                                </div>
                                <Link to="">
                                    <IconButton aria-label="delete">
                                        <ChevronRightIcon />
                                    </IconButton>
                                </Link>
                            </li>

                            <li>
                                <img src='images/ac.png' className='img-fluid' alt='carGenie' />
                                <div className='contentDetails'>
                                    <label> AC Service </label>
                                    <span> Experience superior cooling and comfort with our expert AC Service. </span>
                                </div>
                                <Link to="">
                                    <IconButton aria-label="delete">
                                        <ChevronRightIcon />
                                    </IconButton>
                                </Link>
                            </li>

                            <li>
                                <img src='images/painting.png' className='img-fluid' alt='carGenie' />
                                <div className='contentDetails'>
                                    <label> Dent Repairs & Painting </label>
                                    <span> Restores your car's looks and value </span>
                                </div>
                                <Link to="">
                                    <IconButton aria-label="delete">
                                        <ChevronRightIcon />
                                    </IconButton>
                                </Link>
                            </li>

                            <li>
                                <img src='images/car-wash.png' className='img-fluid' alt='carGenie' />
                                <div className='contentDetails'>
                                    <label> Car Spa & Cleaning </label>
                                    <span> Restore your car’s shine with expert care. </span>
                                </div>
                                <Link to="">
                                    <IconButton aria-label="delete">
                                        <ChevronRightIcon />
                                    </IconButton>
                                </Link>
                            </li>

                            <li>
                                <img src='images/detailing-service.png' className='img-fluid' alt='carGenie' />
                                <div className='contentDetails'>
                                    <label> Detailing Services </label>
                                    <span> Deep cleaning and restoration for your vehicle’s appearance. </span>
                                </div>
                                <Link to="">
                                    <IconButton aria-label="delete">
                                        <ChevronRightIcon />
                                    </IconButton>
                                </Link>
                            </li>

                            <li>
                                <img src='images/performance.png' className='img-fluid' alt='carGenie' />
                                <div className='contentDetails'>
                                    <label> Performance Boosters </label>
                                    <span> For that extra adrenaline rush </span>
                                </div>
                                <Link to="">
                                    <IconButton aria-label="delete">
                                        <ChevronRightIcon />
                                    </IconButton>
                                </Link>
                            </li>

                            <li>
                                <img src='images/running-repair.png' className='img-fluid' alt='carGenie' />
                                <div className='contentDetails'>
                                    <label> Running Repairs </label>
                                    <span> Protect your car on-the-go </span>
                                </div>
                                <Link to="">
                                    <IconButton aria-label="delete">
                                        <ChevronRightIcon />
                                    </IconButton>
                                </Link>
                            </li>

                            <li>
                                <img src='images/car-monsoon.png' className='img-fluid' alt='carGenie' />
                                <div className='contentDetails'>
                                    <label> Monsoon Protect </label>
                                    <span> Protect your car from harsh rain </span>
                                </div>
                                <Link to="">
                                    <IconButton aria-label="delete">
                                        <ChevronRightIcon />
                                    </IconButton>
                                </Link>
                            </li>
                        </ul>
                        <div style={{ margin: '20px auto', display: 'block', textAlign: 'center' }}>
                            <Button
                                variant="contained"
                                size="large"
                                className='roundedBox buttonBlue'
                                endIcon={<SendIcon />}
                                onClick={() => navigate('/services')}
                            >View Offerings</Button>
                        </div>
                    </div>
                </div>
            </section>

            <section className='benefits'>
                <div className='container'>
                    <div className='benefitsCont'>
                        <h1> CarGenie Benefits </h1>
                        <label style={{ color: '#fff' }} className='mb-4'>We Understand automobile Engine very well</label>
                        <div className='rowSplit'>
                            <TableContainer size='small' className='tblContSize' component={Paper}>
                                <Table stickyHeader sx={{ minWidth: 'auto' }} aria-label="simple table">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell key="offering" style={{ fontSize: '24px', fontWeight: '400' }}>Offerings</TableCell>
                                            <TableCell key="cargenie" style={{ fontSize: '24px', color: '#5e79bc', fontWeight: '600' }} align="center">CarGenie</TableCell>
                                            <TableCell key="other" style={{ fontSize: '24px', fontWeight: '400' }} align="center">Other Garages</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {rows.map((row) => (
                                            <TableRow key={row.name}
                                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                            >
                                                <TableCell component="th" scope="row">
                                                    <div className='tblFlex'>
                                                        <img src={row.url} className='img-fluid imgTbl' alt='carGenie' />
                                                        <p>{row.title}</p>
                                                    </div>
                                                </TableCell>
                                                <TableCell align="center">
                                                    <img src={row.right} className='img-fluid imgTblXl' alt='carGenie' />
                                                </TableCell>
                                                <TableCell align="center">
                                                    <img src={row.wrong} className='img-fluid imgTblXl' alt='carGenie' />
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>

                            <div className='engineCont'>
                                <img src='images/engine.png' className='img-fluid engine' alt='carGenie' />

                                <p>
                                    When you bring your vehicle to Ducatibox Car Mechanic Center, you can rest easy knowing that your vehicle is in professional hands. We take every possible step to ensure that your experience with us is pleasant and efficient.
                                </p>

                                <div className='btnPos'>
                                    <Button
                                        variant="contained"
                                        size="large"
                                        className='roundedBox buttonBlue me-4'
                                        // endIcon={<SendIcon />} 
                                        href="https://api.whatsapp.com/send?phone=7003900368"
                                        startIcon={<WhatsAppIcon />}>
                                        Schedule A Pickup
                                    </Button>

                                    <Button
                                        variant="contained"
                                        color="secondary"
                                        size="large"
                                        className='roundedBox buttonBlue'
                                        endIcon={<SendIcon />}
                                        // onClick={scheduleRide}
                                        onClick={handleClickOpenCar}
                                    // onClick={() => navigate('/services')}
                                    >
                                        Book A Service
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className='testimonial'>
                <div className='container'>
                    <div className='testimonialCont'>
                        <h1> Clients Testimonial </h1>
                        <label className='headLabel'>What Our Clients Say About Car Genie...</label>
                        <Swiper
                            // spaceBetween={25}
                            // slidesPerView={2}
                            // onSlideChange={() => console.log('slide change')}
                            // onSwiper={(swiper) => console.log(swiper)}

                            breakpoints={{
                                640: {
                                    slidesPerView: 1,
                                    spaceBetween: 0,
                                },
                                768: {
                                    slidesPerView: 1,
                                    spaceBetween: 40,
                                },
                                1024: {
                                    slidesPerView: 2,
                                    spaceBetween: 25,
                                },
                            }}
                            loop={true}

                            autoplay={{
                                delay: 4500,
                                disableOnInteraction: true,
                            }}

                            effect={'coverflow'}
                            grabCursor={true}
                            centeredSlides={true}
                            // slidesPerView={'auto'}
                            coverflowEffect={{
                                rotate: 50,
                                stretch: 0,
                                depth: 100,
                                modifier: 1,
                                slideShadows: true,
                            }}
                            modules={[EffectCoverflow, Autoplay]}
                        >
                            <SwiperSlide>
                                <div className='ratingCont'>
                                    <img src='images/user.png' className='img-fluid rateImg' alt='car genie' />
                                    <div className='ratingContent'>
                                        <label>Ujjal Das</label>
                                        <p>
                                            I am very much satisfied about my car work.  All the staff behavior r very good . I am recommend every one to go and visit car genie to get a new look of your car.
                                        </p>
                                        <div className='rating'>
                                            <img src='images/star.png' className='img-fluid' alt='car genie' />
                                            <img src='images/star.png' className='img-fluid' alt='car genie' />
                                            <img src='images/star.png' className='img-fluid' alt='car genie' />
                                            <img src='images/star.png' className='img-fluid' alt='car genie' />
                                            <img src='images/star_grey.png' className='img-fluid' alt='car genie' />
                                        </div>
                                    </div>
                                </div>
                            </SwiperSlide>

                            <SwiperSlide>
                                <div className='ratingCont'>
                                    <img src='images/user.png' className='img-fluid rateImg' alt='car genie' />
                                    <div className='ratingContent'>
                                        <label>Tapan Bajpayee</label>
                                        <p>
                                            Car Genie completely transformed my Honda City into a masterpiece! From sleek exterior upgrades to luxurious interior enhancements, every detail exceeded my expectations. Plus,the added safety features give me peace of mind on the road.Their expertise and attention to detail are unmatched. Highly recommend Car Genie for anyone looking to elevate their ride!
                                        </p>
                                        <div className='rating'>
                                            <img src='images/star.png' className='img-fluid' alt='car genie' />
                                            <img src='images/star.png' className='img-fluid' alt='car genie' />
                                            <img src='images/star.png' className='img-fluid' alt='car genie' />
                                            <img src='images/star.png' className='img-fluid' alt='car genie' />
                                            <img src='images/star.png' className='img-fluid' alt='car genie' />
                                        </div>
                                    </div>
                                </div>
                            </SwiperSlide>

                            <SwiperSlide>
                                <div className='ratingCont'>
                                    <img src='images/user.png' className='img-fluid rateImg' alt='car genie' />
                                    <div className='ratingContent'>
                                        <label>Moyukh Bhattacharya</label>
                                        <p>
                                            Had my car serviced from Car Genie. They were very prompt, listen to issues and update on every step taken towards my car. Consistently informing over call and WhatsApp. No unnecessary charges and overpriced services. It had been a good experience
                                        </p>
                                        <div className='rating'>
                                            <img src='images/star.png' className='img-fluid' alt='car genie' />
                                            <img src='images/star.png' className='img-fluid' alt='car genie' />
                                            <img src='images/star.png' className='img-fluid' alt='car genie' />
                                            <img src='images/star.png' className='img-fluid' alt='car genie' />
                                            <img src='images/star.png' className='img-fluid' alt='car genie' />
                                        </div>
                                    </div>
                                </div>
                            </SwiperSlide>

                            <SwiperSlide>
                                <div className='ratingCont'>
                                    <img src='images/user.png' className='img-fluid rateImg' alt='car genie' />
                                    <div className='ratingContent'>
                                        <label>Bappaditya Chakraborty</label>
                                        <p>
                                            Went to Car Genie with my Honda Amaze. Had some issues that authorised service centre suggested to replace parts. I had doubt and went here which is near by my location. They did the work well and saved me with unnecessary money wastage. Thanks to the team. Hope u keep ur good work and gain faith.
                                        </p>
                                        <div className='rating'>
                                            <img src='images/star.png' className='img-fluid' alt='car genie' />
                                            <img src='images/star.png' className='img-fluid' alt='car genie' />
                                            <img src='images/star.png' className='img-fluid' alt='car genie' />
                                            <img src='images/star.png' className='img-fluid' alt='car genie' />
                                            <img src='images/star.png' className='img-fluid' alt='car genie' />
                                        </div>
                                    </div>
                                </div>
                            </SwiperSlide>

                            <SwiperSlide>
                                <div className='ratingCont'>
                                    <img src='images/user.png' className='img-fluid rateImg' alt='car genie' />
                                    <div className='ratingContent'>
                                        <label>Arindam Saha</label>
                                        <p>
                                            First and foremost I want to really thanks to the employees for their nice gesture and behaviour. The service provide by the Dunlop Car Genie is good. Will prefer to visit again for further services. I have visited second time again for the service. The service was really good and their behaviour is good as it was earlier.
                                        </p>
                                        <div className='rating'>
                                            <img src='images/star.png' className='img-fluid' alt='car genie' />
                                            <img src='images/star.png' className='img-fluid' alt='car genie' />
                                            <img src='images/star.png' className='img-fluid' alt='car genie' />
                                            <img src='images/star.png' className='img-fluid' alt='car genie' />
                                            <img src='images/star.png' className='img-fluid' alt='car genie' />
                                        </div>
                                    </div>
                                </div>
                            </SwiperSlide>
                        </Swiper>

                        <div className='testimonialBtn'>
                            <Button
                                variant="contained"
                                color="secondary"
                                size="large"
                                className='roundedBox buttonBlue'
                                endIcon={<SendIcon />}
                                onClick={() => window.open('https://g.co/kgs/7Q72tqU', '_blank')}
                            >Rate Us </Button>
                        </div>
                    </div>
                </div>
            </section>

            <section className='teamContainer galleryCont'>
                <div className='container'>
                    <div className="serviceCont">
                        <h1 style={{width: '48%'}}> Meet Our Experts </h1>
                        <h6 style={{marginTop: '1.2rem'}}> The Core Strength of Car Genie Kolkata </h6>
                    </div>
                    <h5>
                        At Car Genie Kolkata, we take pride in our team of industry-certified professionals who bring decades of expertise, precision, and passion to every vehicle they touch. Each of our experts represents the finest in their domain — combining years of hands-on experience with top-tier training from leading automotive brands.
                    </h5>
                    <div className='sectionTeam'>
                        {memberList.map((items) => (
                            <div className="card__container">
                                <article className="card__article">
                                    <img src={`images/${items.name}`} alt="image" className="card__img" />

                                        <div className="card__data">
                                            <h2 className="card__title">{items.memberDetails[0].name} </h2>
                                            <div className="card__description"> 
                                                <img src='images/xp.png' className='me-1' alt='xp' /> 
                                                <span> {items.memberDetails[0].experience} <br/>
                                                 {items.memberDetails[0].experienceDesc} </span>
                                            </div>                                         
                                            <Link to="/Team" className="card__button">Read More</Link>
                                        </div>
                                </article>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* <Gallery ref={galleryRef} /> */}

            {/* <Footer ref={contactRef} /> */}

            {/* DIALOG BOX FOR CAR SELECTION */}
            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                className="dialogBoxResponsive"
            >
                <DialogTitle id="alert-dialog-title">
                    {"GET FREE QUOTE"}
                </DialogTitle>
                <DialogContent>
                    {/* <DialogContentText id="alert-dialog-description"> */}
                    <form className='formBox' onSubmit={handleSubmit(onSubmit)}>
                        <div className='formMsgBox'>
                            <div className='d-flex flex-column w-48'>
                                <TextField
                                    id="First Name"
                                    label="First Name"
                                    // color="secondary"
                                    {...register("firstName", {
                                        required: "First Name is required!",
                                        minLength: {
                                            value: 4, message: "Minimum 4 characters required"
                                        },
                                    })}
                                    slotProps={{
                                        input: {
                                            startAdornment: (
                                                <InputAdornment position="start">
                                                    <AccountCircle />
                                                </InputAdornment>
                                            ),
                                        },
                                    }}
                                    // variant="filled"
                                    className='w-100'
                                />
                                {errors.firstName && <span className='errorMsg'>{errors.firstName.message}</span>}
                            </div>

                            <div className='d-flex flex-column w-48'>
                                <TextField
                                    id="Last Name"
                                    label="Last Name"
                                    // color="secondary"
                                    {...register("lastName", {
                                        required: "Last Name is required!",
                                        minLength: { value: 4, message: "Minimum 4 characters required" }
                                    })}
                                    slotProps={{
                                        input: {
                                            startAdornment: (
                                                <InputAdornment position="start">
                                                    <AccountCircle />
                                                </InputAdornment>
                                            ),
                                        },
                                    }}
                                    // variant="filled"
                                    className='w-100'
                                />
                                {errors.lastName && <span className='errorMsg'>{errors.lastName.message}</span>}
                            </div>
                        </div>

                        <div className='formMsgBox'>
                            <div className='d-flex flex-column w-48'>
                                <TextField
                                    type='email'
                                    id="Email"
                                    label="Email"
                                    {...register("email",
                                        {
                                            required: "Email is required!",
                                            pattern: {
                                                value: /\S+@\S+\.\S+/,
                                                message: "Entered value does not match email format",
                                            },
                                        }
                                    )}
                                    // color="secondary"
                                    slotProps={{
                                        input: {
                                            startAdornment: (
                                                <InputAdornment position="start">
                                                    <AlternateEmailIcon />
                                                </InputAdornment>
                                            ),
                                        },
                                    }}
                                    // variant="filled"
                                    className='w-100'
                                />
                                {errors.email && <span className='errorMsg'>{errors.email.message}</span>}
                            </div>

                            <div className='d-flex flex-column w-48'>
                                <TextField
                                    // type='number'
                                    id="contact"
                                    label="Contact"
                                    // color="secondary"
                                    // variant="filled"
                                    {...register("contact", { 
                                        required: "Contact is required!",
                                        minLength: { value: 10, message: "Minimum 10 digit required" }, maxLength: { value: 10, message: "Maximum 10 digit allowed" }
                                    })}
                                    slotProps={{
                                        input: {
                                            startAdornment: (
                                                <InputAdornment position="start">
                                                    <CallIcon />
                                                </InputAdornment>
                                            ),
                                        },
                                    }}
                                    className='w-100'
                                />
                                {errors.contact && <span className='errorMsg'>{errors.contact.message}</span>}
                            </div>
                        </div>

                        <div className='formMsgBox'>
                            <div className='d-flex flex-column w-48'>
                            <TextField
                                // type='text'
                                id="vehicle brand"
                                label="Vehicle Brand Name"
                                className='w-100'
                                {...register("brandName", { required: "Please Enter Vehicle Brand Name!" })}
                                slotProps={{
                                    input: {
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <DirectionsCarIcon />
                                            </InputAdornment>
                                        ),
                                    },
                                }}
                            />
                            {errors.brandName && <span className='errorMsg'>{errors.brandName.message}</span>}
                            </div>

                            <div className='d-flex flex-column w-48'>
                            <TextField
                                // type='text'
                                id="Vehicle name"
                                label="Vehicle Name"
                                // color="secondary"
                                // focused
                                // variant="filled"
                                {...register("carName", { required: "Please Enter Vehicle Name!" })}
                                slotProps={{
                                    input: {
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <DirectionsCarIcon />
                                            </InputAdornment>
                                        ),
                                    },
                                }}
                                className='w-100'
                            />
                            {errors.carName && <span className='errorMsg'>{errors.carName.message}</span>}
                            </div>
                        </div>

                        <TextField
                            id="outlined-select-currency"
                            select
                            label="Select Vehicle Type"
                            // onChange={getCarType}
                            defaultValue=""
                            // value={carType}
                            {...register("carType", { required: "Please Enter Vehicle Type!" })}
                            slotProps={{
                                input: {
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <DirectionsCarIcon />
                                        </InputAdornment>
                                    ),
                                },
                            }}
                            error={!!errors.carType}
                            helperText={errors.carType?.message}
                            className='mb-4'
                        // variant="filled"
                        // color="secondary"
                        // style={{ background: "rgb(133 129 129 / 79%)" }}
                        >
                            {/* {vehicleType.map((option) => ( */}
                            <MenuItem value="">Select Car Type</MenuItem>
                            <MenuItem value={"petrol"}> Petrol </MenuItem>
                            <MenuItem value={"diesel"}> Diesel </MenuItem>
                            <MenuItem value={"cng"}> CNG </MenuItem>
                            <MenuItem value={"electric"}> Electric </MenuItem>
                            {/* ))} */}
                        </TextField>

                        <TextField
                            id="Subject"
                            label="Subject"
                            // color="secondary"
                            // variant="filled"
                            {...register("subject")}
                            slotProps={{
                                input: {
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <BentoIcon />
                                        </InputAdornment>
                                    ),
                                },
                            }}
                            style={{ marginBottom: '20px' }}
                        />

                        <TextField
                            id="Message"
                            label="Message"
                            multiline
                            rows={4}
                            color="secondary"
                            {...register("message")}
                        // variant="filled"
                        // style={{ marginBottom: '20px', background: 'rgb(146 146 146 / 79%)' }}
                        />
                        <div className='btnClass mt-4'>
                            {/* <Button variant="contained" color="secondary" className='roundedBox buttonBlue' type="submit" href="https://api.whatsapp.com/send?phone=7003900368" startIcon={<SendIcon />}> Connect Now  </Button> */}
                            <Button type='submit' variant="contained" color="secondary" className='roundedBox buttonBlue' endIcon={<SendIcon />} disabled={isSubmitting}> Connect Now </Button>
                        </div>
                    </form>
                    {/* </DialogContentText> */}
                </DialogContent>
                <DialogActions>
                    {/* <Button onClick={handleClose}>Disagree</Button> */}
                    <Button onClick={handleClose} autoFocus>
                        Close
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    )
}

export default Home